import React from "react";
import { Mail, Phone, ArrowRight, Send, Loader, Building2, User, MessageSquare } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function TransformationForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div data-section-id="7286" className="flex flex-col items-center justify-center py-12 text-center space-y-4 animate-in fade-in zoom-in duration-500">
        <div className="size-16 rounded-lg bg-[#eab308]/20 flex items-center justify-center mb-4">
          <Send className="size-8 text-[#eab308]" />
        </div>
        <h3 className="text-2xl font-bold text-white">¡Mensaje Recibido!</h3>
        <p className="text-white/70 max-w-md mx-auto">{successMessage}</p>
        <Button variant="outline" className="mt-6 border-[#eab308] text-[#eab308] hover:bg-[#eab308] hover:text-[#0a1120]" onClick={() => window.location.reload()}>
          Enviar otro mensaje
        </Button>
      </div>;
  }
  return <Form className="space-y-8" onSubmit={e => {
    e.preventDefault();
    handleSubmit();
  }}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {}
        <FormField control={control} name="name" rules={{
        required: "El nombre es obligatorio"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-white/60 uppercase tracking-widest text-xs font-mono">Nombre Completo</FormLabel>
              <FormControl>
                <div className="relative group">
                  <User className="absolute left-0 top-2.5 size-4 text-white/30 group-focus-within:text-[#3b82f6] transition-colors" />
                  <Input placeholder="Tu nombre" {...field} className="pl-8 border-0 border-b border-white/10 bg-transparent px-0 py-6 text-white placeholder:text-white/20 focus-visible:ring-0 focus-visible:border-[#3b82f6] transition-all duration-300" />
                </div>
              </FormControl>
              <FormMessage />
            </FormItem>} />

        {}
        <FormField control={control} name="email" rules={{
        required: "El correo es obligatorio",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Correo electrónico inválido"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-white/60 uppercase tracking-widest text-xs font-mono">Correo de Contacto</FormLabel>
              <FormControl>
                <div className="relative group">
                  <Mail className="absolute left-0 top-2.5 size-4 text-white/30 group-focus-within:text-[#3b82f6] transition-colors" />
                  <Input type="email" placeholder="tu@email.com" {...field} className="pl-8 border-0 border-b border-white/10 bg-transparent px-0 py-6 text-white placeholder:text-white/20 focus-visible:ring-0 focus-visible:border-[#3b82f6] transition-all duration-300" />
                </div>
              </FormControl>
              <FormMessage />
            </FormItem>} />

        {}
        <FormField control={control} name="phone" rules={{
        required: "El teléfono es obligatorio",
        pattern: {
          value: /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/,
          message: "Número de teléfono inválido"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-white/60 uppercase tracking-widest text-xs font-mono">WhatsApp / Teléfono</FormLabel>
              <FormControl>
                <div className="relative group">
                  <Phone className="absolute left-0 top-2.5 size-4 text-white/30 group-focus-within:text-[#eab308] transition-colors" />
                  <Input type="tel" placeholder="+34 000 000 000" {...field} className="pl-8 border-0 border-b border-white/10 bg-transparent px-0 py-6 text-white placeholder:text-white/20 focus-visible:ring-0 focus-visible:border-[#eab308] transition-all duration-300" />
                </div>
              </FormControl>
              <FormMessage />
            </FormItem>} />

        {}
        <FormField control={control} name="company" render={({
        field
      }) => <FormItem>
              <FormLabel className="text-white/60 uppercase tracking-widest text-xs font-mono">Tipo de Negocio</FormLabel>
              <FormControl>
                <div className="relative group">
                  <Building2 className="absolute left-0 top-2.5 size-4 text-white/30 group-focus-within:text-[#3b82f6] transition-colors" />
                  <Input placeholder="Ej: Carpintería, Taller, Bar..." {...field} className="pl-8 border-0 border-b border-white/10 bg-transparent px-0 py-6 text-white placeholder:text-white/20 focus-visible:ring-0 focus-visible:border-[#3b82f6] transition-all duration-300" />
                </div>
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      {}
      <FormField control={control} name="message" render={({
      field
    }) => <FormItem>
            <FormLabel className="text-white/60 uppercase tracking-widest text-xs font-mono">¿Qué objetivos tienes para este mes?</FormLabel>
            <FormControl>
              <div className="relative group">
                <MessageSquare className="absolute left-0 top-4 size-4 text-white/30 group-focus-within:text-[#3b82f6] transition-colors" />
                <textarea placeholder="Cuéntanos brevemente cómo podemos ayudarte a conseguir más clientes..." {...field} className="w-full pl-8 min-h-[100px] border-0 border-b border-white/10 bg-transparent px-0 py-4 text-white placeholder:text-white/20 focus-visible:outline-none focus-visible:border-[#3b82f6] transition-all duration-300 resize-y" />
              </div>
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-4 bg-red-500/10 border border-red-500/20 rounded-lg">
          <p className="text-red-400 text-sm">{submitError}</p>
        </div>}

      <Button type="submit" onClick={handleSubmit} disabled={isSubmitting} className="w-full h-14 text-lg font-bold bg-gradient-to-r from-[#eab308] to-[#ca8a04] text-[#0a1120] hover:opacity-90 transition-opacity border-0 rounded-md">
        Enviar solicitud
        <ArrowRight className="ml-2 size-5" />
      </Button>
    </Form>;
}
export default function IniciemosTuTransformacion() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="listo-para-crecer" className="dark bg-[#0a1120] text-[#f8fafc] relative py-24 lg:py-32 overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-[#3b82f6]/10 rounded-lg blur-[120px] mix-blend-screen" />
        <div className="absolute bottom-0 right-1/4 w-[500px] h-[500px] bg-[#eab308]/10 rounded-lg blur-[120px] mix-blend-screen" />
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1611697/img/grid_pattern.png)] opacity-[0.03]" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div ref={ref} className={`max-w-6xl mx-auto transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <div className="grid lg:grid-cols-12 gap-8 lg:gap-12 items-start">
            
            {}
            <div className="lg:col-span-8">
              <div className="relative rounded-lg overflow-hidden border border-white/10 bg-white/5 backdrop-blur-2xl shadow-2xl">
                {}
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#3b82f6] via-[#eab308] to-[#3b82f6]" />
                
                <div className="p-8 md:p-12">
                  <div className="mb-10">
                    <h2 className="text-4xl md:text-5xl font-bold text-white mb-4 tracking-tighter">
                      ¿Listo para tu Transformación Digital? <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#3b82f6] to-[#eab308]">evolucionar?</span>
                    </h2>
                    <p className="text-white/60 text-lg">Consulta estratégica gratuita: descubre cómo implementar soluciones AI, automatización de procesos y sistemas digitales inteligentes en tu operación.</p>
                  </div>

                  <FormProvider formKey="take_control_form_home" formId="take_control_form_home" sectionName="lead-capture-home" useSmtp={true} emailRecipient="jr.recla@outlook.com" defaultValues={{
                  name: "",
                  email: "",
                  phone: "",
                  company: "",
                  message: ""
                }} validationRules={{
                  name: {
                    required: true
                  },
                  email: {
                    required: true,
                    pattern: "email"
                  },
                  phone: {
                    required: true,
                    pattern: "phone"
                  },
                  company: {
                    required: false
                  },
                  message: {
                    required: false
                  }
                }} submitText="Contactar por WhatsApp" successMessage="Gracias. Hemos recibido tu solicitud y te responderemos pronto." errorMessage="Hubo un error al enviar el formulario. Por favor, inténtalo de nuevo o llámanos directamente." className="w-full">
                    <TransformationForm />
                  </FormProvider>
                </div>
              </div>
            </div>

            {}
            <div className="lg:col-span-4 space-y-6 lg:pt-12">
              <div className="p-6 rounded-lg border border-white/5 bg-white/5 backdrop-blur-xl hover:bg-white/10 transition-colors group">
                <div className="flex items-start gap-4">
                  <div className="p-3 rounded-md bg-[#3b82f6]/10 text-[#3b82f6] group-hover:scale-110 transition-transform">
                    <Mail className="size-6" />
                  </div>
                  <div>
                    <h3 className="text-sm font-mono text-white/50 uppercase tracking-widest mb-1">Escríbenos</h3>
                    <Link to="mailto:jr.recla@outlook.com" className="text-lg font-medium text-white hover:text-[#3b82f6] transition-colors break-all">jr.recla@outlook.com</Link>
                  </div>
                </div>
              </div>

              <div className="p-6 rounded-lg border border-white/5 bg-white/5 backdrop-blur-xl hover:bg-white/10 transition-colors group">
                <div className="flex items-start gap-4">
                  <div className="p-3 rounded-md bg-[#eab308]/10 text-[#eab308] group-hover:scale-110 transition-transform">
                    <Phone className="size-6" />
                  </div>
                  <div>
                    <h3 className="text-sm font-mono text-white/50 uppercase tracking-widest mb-1">Llámanos</h3>
                    <Link to="tel:+34602505574" className="text-lg font-medium text-white hover:text-[#eab308] transition-colors">+34 602 505574 / 602 578196</Link>
                    <p className="text-sm text-white/40 mt-1">Soporte Prioritario WhatsApp</p>
                  </div>
                </div>
              </div>

              <div className="p-6 rounded-lg border border-white/5 bg-white/5 backdrop-blur-xl">
                <h3 className="text-xl font-bold text-white mb-4">¿Por qué elegirnos?</h3>
                <ul className="space-y-3">
                  {["Sistemas AI & Automatización", "Arquitectura Digital Escalable", "Integración Técnica Sin Fricciones", "Soporte Empresarial Prioritario"].map((item, i) => <li key={i} data-index={i} className="flex items-center gap-3 text-white/70">
                      <div className="size-1.5 rounded-lg bg-[#eab308]" />
                      {item}
                    </li>)}
                </ul>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>;
}